import classNames from 'classnames';

import { ImageEmbedded } from '../image/image-embedded';
import { Text } from '../text/text.component';
import { TitleV2 } from '../titlev2/titlev2.component';

import { FeaturedStatIsEmptyFn, FeaturedStatProps } from './featured-stat.config';

export const FeaturedStat = ({
  image,
  statNumber,
  statText,
  alignment,
  isInEditor,
  additionalClasses,
  propertiesId,
  propertiesLabel,
  propertiesRole,
  ...props
}: FeaturedStatProps) => {
  return !FeaturedStatIsEmptyFn({
    image,
    statNumber,
    statText,
    alignment,
    isInEditor,
    additionalClasses,
    propertiesId,
    propertiesLabel,
    propertiesRole,
    ...props,
  }) ? (
    <div
      id={propertiesId}
      aria-label={propertiesLabel}
      role={propertiesRole}
      data-testid="snowflake-featured-stat"
      className={classNames('snowflake-featured-stat', `alignment-${alignment}`, additionalClasses)}
    >
      {image && (
        <div data-testid="snowflake-featured-stat-image" className="snowflake-featured-stat-image-container">
          <ImageEmbedded baseCssClass="snowflake-featured-stat-image" {...image} />
        </div>
      )}
      <div className={classNames('snowflake-featured-stat-stat-container', `alignment-${alignment}`)}>
        <div className="snowflake-featured-stat-stat-number">
          <TitleV2 {...statNumber} />
        </div>
        <div className="snowflake-featured-stat-stat-text text-size-small">
          <Text {...statText} />
        </div>
      </div>
    </div>
  ) : null;
};

export default FeaturedStat;
